import React from 'react';
import PageHero from '../components/layout/PageHero';
import { ToolGuideCta } from '../components/layout/GuideLayout';
import DataConverter from '../components/tools/DataConverter';

const DataConverterPage = () => {
  return (
    <div className="min-h-screen" data-testid="data-converter-page">
      <PageHero
        eyebrow="Engineering Utilities"
        title="Data Converter"
        description="Convert between hex, decimal, and binary, and view big-endian / little-endian byte order."
        backTo="/tools"
        backLabel="Back to Tools"
        testId="data-converter-hero"
      />
      <section className="py-12 md:py-16">
        <div className="max-w-screen-2xl mx-auto px-4 md:px-8">
          <DataConverter />
          <ToolGuideCta guidePath="/tools/data-converter/guide" toolName="Data Converter" />
        </div>
      </section>
    </div>
  );
};

export default DataConverterPage;
